import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/openOrdersReport'
import Component from 'components/Reports/OpenOrdersReport'

export default createListViewContainer({ actions, selectors: selectors.openOrdersReport })(Component)
